import React from 'react'
import styles from '../../styles/solution.module.css';
import SectionTitle from '../common/SectionTitle';
import { IMAGEPATH } from '../../constants/imagePath';
import SolutionIndustriesCard from './SolutionIndustriesCard';
import { KR } from '../../constants/localizations';

export default function SolutionIndustries() {
    return (
        <div className={styles.ind}>
            <SectionTitle title={KR.label_solution_ind_intro} titleEng={KR.label_solution_ind_intro_eng} />
            <div className={styles.cardW}>
                <SolutionIndustriesCard title={KR.label_home_delivery_robot} content={KR.label_solution_ind_delivery_detail} image={IMAGEPATH.robots1} imageWebp={IMAGEPATH.robots1Webp} />
                <SolutionIndustriesCard title={KR.label_home_logi_robot} content={KR.label_solution_ind_logi_detail} image={IMAGEPATH.robots2} imageWebp={IMAGEPATH.robots2Webp} />
                <SolutionIndustriesCard title={KR.label_solution_ind_total_solution} content={KR.label_solution_ind_total_detail} image={IMAGEPATH.solution} imageWebp={IMAGEPATH.solutionWebp} />
            </div>
        </div>
    )
}
